<template>
  <div class="d-flex justify-center align-center mt-2 mb-2 counter">
    <div class="mr-2 custom-item-counter d-flex">
      <p class="d-flex justify-center align-center" :style="`color: #${textColor}`">{{ $t('days') }}:</p>
      <h1 class="ml-1 d-flex justify-center" :style="`color: #${titleColor}; margin-right:5px;`">{{ displayDays }}</h1>
    </div>
    <div class="mr-2 custom-item-counter d-flex">
      <p class="d-flex justify-center align-center" :style="`color: #${textColor}`">{{ $t('hours') }}:</p>
      <h1 class="ml-1 d-flex justify-center" :style="`color: #${titleColor}; margin-right:5px;`">{{ displayHours }}</h1>
    </div>
    <div class="mr-2 custom-item-counter d-flex">
      <p class="d-flex justify-center align-center" :style="`color: #${textColor}`">{{ $t('minutes') }}:</p>
      <h1 class="ml-1 d-flex justify-center" :style="`color: #${titleColor}; margin-right:5px;`">{{ displayMinute }}</h1>
    </div>
    <div class="custom-item-counter d-flex">
      <p class="d-flex justify-center align-center" :style="`color: #${textColor}`">{{ $t('seconds') }}:</p>
      <h1 class="ml-1 d-flex justify-center" :style="`color: #${titleColor}; margin-right:5px;`">{{ displaySeconds }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "Counter",
  props: {
    endTime: Date,
    titleColor: String,
    textColor: String,
  },
  data() {
    return {
      displaySeconds: 0,
      displayMinute: 0,
      displayHours: 0,
      displayDays: 0,
    };
  },
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
  },
  mounted() {
    this.showRemaining();
  },
  methods: {
    showRemaining() {
      const timer = setInterval(() => {
        let now = new Date();
        let distance = this.endTime.getTime() - now.getTime();
        if (distance < 0) {
          clearInterval(timer);
          return;
        }

        let days = Math.floor(distance / this._days);
        let hours = Math.floor((distance % this._days) / this._hours);
        let mins = Math.floor((distance % this._hours) / this._minutes);
        let secs = Math.floor((distance % this._minutes) / this._seconds);
        this.displayDays = (days < 10) ? `0${days}` : days;
        this.displayHours = (hours < 10) ? `0${hours}` : hours;
        this.displayMinute = (mins < 10) ? `0${mins}` : mins;
        this.displaySeconds = (secs < 10) ? `0${secs}` : secs;
      }, 1000);
    },
  }
}
</script>



<style lang="scss">
.counter {
  h1 {
    @media (max-width: 1290px) {
      color: var(--v-mainBlack-base);
      font-size: 12px;
      font-weight: normal;
    }
  }

  p {
    @media (max-width: 1290px) {
      color: var(--v-mainBlack-base);
      font-size: 12px;
      font-weight: bold;
    }
  }

  .custom-item-counter{
    @media (min-width: 1290px) {
      flex-direction: column;

    }
  }
}
</style>
